/**
 * @generated SignedSource<<b5bd7011d13b608003925d34a9fa9c25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type contactTeamMemberDeleteMutation$variables = {
  ID: string;
};
export type contactTeamMemberDeleteMutation$data = {
  readonly deleteContactTeamMember: {
    readonly id: string;
  };
};
export type contactTeamMemberDeleteMutation = {
  variables: contactTeamMemberDeleteMutation$variables;
  response: contactTeamMemberDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "ID"
      }
    ],
    "concreteType": "ContactTeamMemberDeletePayload",
    "kind": "LinkedField",
    "name": "deleteContactTeamMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactTeamMemberDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactTeamMemberDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e322908dacb50b2e2c29f8787c9badbb",
    "id": null,
    "metadata": {},
    "name": "contactTeamMemberDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation contactTeamMemberDeleteMutation(\n  $ID: ID!\n) {\n  deleteContactTeamMember(id: $ID) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1255c227b70ae04b6e1fad55286633c";

export default node;
